module.exports = __webpack_public_path__ + "img/link.6e4a0f61.svg";